// Locally, we use mock values for feature flags and do not hit flagsmith directly.
// This allows us to make our tests independent of flagsmith, and to test both branches

// without flipping flags for everyone else.
export const localFlagValues = {
  'flagsmith-initialized': {
    // See comment in SessionProvider for why this flag exists.
    enabled: true,
  },
  'billing-tab-enabled': {
    enabled: true,
  },
  'unit-integration-enabled': {
    enabled: true,
  },
  'fragment-inc-dashboard-pages': {
    enabled: true,
  },
  'stripe-integration-enabled': {
    enabled: true,
  },
  'line-download-enabled': {
    enabled: true,
  },
  'ai-schema-generation-enabled': {
    enabled: true,
  },
  'detail-reskin-enabled': {
    enabled: true,
  },
  'enable-template-library': {
    enabled: true,
  },
  'demo-mode-enabled': {
    enabled: true,
  },
  'dashboard-archive-enabled': {
    enabled: true,
  },
  'dashboard-hide-name': {
    enabled: false,
  },
  'dashboard-total-balance-enabled': {
    enabled: true,
  },
  'dashboard-payments': {
    enabled: false,
  },
};

export type DashboardFlags = keyof typeof localFlagValues;
export type DashboardFlagOverrides = Partial<typeof localFlagValues>;
